import type { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import { validPolishStreetAddress } from 'src/shared/validatorUtils';
import { RuleArgs } from '.';

export const streetAddressRule = ({ required }: RuleArgs): Rule => {
  const { t } = useTranslation();

  return ({
    required,
    message: t('Please enter correct street address'),
    validator: (_, value: string) => {
      if (required && !value) {
        return Promise.reject();
      }

      return (
        !value || validPolishStreetAddress(value)
          ? Promise.resolve()
          : Promise.reject());
    },
  });
};
